import {create} from 'zustand'

type State = {
  open: boolean
  toggle: () => void
  close: () => void
  openDrawer: () => void
}

// Drawer state for the floating Inbox widget (mirrors policyChatDrawerStore).
export const useInboxDrawerStore = create<State>((set) => ({
  open: false,
  toggle: () => set((state) => ({open: !state.open})),
  close: () => set({open: false}),
  openDrawer: () => set({open: true}),
}))
